import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { BrowserStorageLocalService } from 'pf-frontend-common/src/service/browser-storage-local/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { ApplicationFeature } from './feature';

export function ApplicationFeatureFactory(): ApplicationFeature {
  return new ApplicationFeature(EventEmitterFactory(), BrowserStorageLocalService(), WindowService());
}
